import React from "react";
import { useTranslation } from "react-i18next";

const FormInput = ({
  id,
  type,
  name,
  value,
  onChange,
  label,
  error,
  onClear,
  autoCapitalize,
}) => {
  const { t } = useTranslation();
  return (
    <div className="mb-6">
      <div className="relative">
        <input
          id={id}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder=" "
          autoCapitalize={autoCapitalize}
          className={`block w-full px-4 pt-6 pb-2 border rounded-md focus:outline-none focus:ring-1 ${
            error 
              ? "border-red-500 focus:ring-red-300"
              : "focus:ring-slate-400 border-gray-300"
          } peer transition-all duration-200 text-gray-800`}
        />
        {value && (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-3 top-5 text-gray-400 hover:text-gray-600 focus:outline-none"
            aria-label={t("form_input.clear_button_aria")}
          >
            <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
              <path d="M15 9L9 15M9 9L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        )}
        <label
          htmlFor={id}
          className={`absolute duration-200 transform -translate-y-3 scale-75 top-4 z-10 origin-[0] left-4
          peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0
          peer-focus:scale-75 peer-focus:-translate-y-3 ${
            error ? "text-red-500" : "text-gray-500 peer-focus:text-slate-700"
          }`}
        >
          {label}
        </label>
        {error && (
          <p className="mt-1 text-xs text-red-500">{error}</p>
        )}
      </div>
    </div>
  );
};

export default FormInput;
